import "core-js/modules/es.promise.js";
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import { doLogout as logout, isUserLogged as checkUserLogged, doLogin, doProLogin } from "../components/loginAPI";
import { removeFirebaseToken } from "../Firebase/FirebaseMessaging/firebaseMessaging";
//@ts-ignore
import { encodeCookie } from "@utils/CookieUtils";
//@ts-ignore
import { initGoogleSignIn } from "@wkWebSrc/js/components/googleSignin";
import { defineStore } from "pinia";
import { ref, computed } from "vue";
//@ts-ignore
import { redirect } from "@utils/RedirectUtils";
//@ts-ignore
import { useCommonVars } from "@wkComposables/useCommonVars";
export var useLoggedUserStore = defineStore("loggedUserStoreId", () => {
  var isLogged = ref(null);
  var isUserLogged = computed(() => isLogged.value);
  var {
    baseURLIt
  } = useCommonVars();
  var changeLoggedUserState = loggedState => {
    isLogged.value = loggedState;
  };
  var login = payload => __awaiter(void 0, void 0, void 0, function* () {
    try {
      yield doLogin(payload);
      initGoogleSignIn();
      changeLoggedUserState(true);
      return null;
    } catch (e) {
      console.error("public user login failed", e);
      changeLoggedUserState(false);
      // if the login fails, try to login as a pro user
      try {
        yield doProLogin(payload);
        redirect({
          url: "".concat(baseURLIt.value, "/pro/")
        });
        return null;
      } catch (e) {
        console.error("pro login failed", e);
      }
      return e;
    }
  });
  var checkIfUserIsLogged = () => __awaiter(void 0, void 0, void 0, function* () {
    var _isUserLogged = yield checkUserLogged();
    changeLoggedUserState(_isUserLogged);
    //TODO: Temp fix per il menu!!!
    //@ts-ignore
    window["_logged"] = _isUserLogged;
  });
  var doLogout = () => __awaiter(void 0, void 0, void 0, function* () {
    encodeCookie("googleOnetapCooldown", {
      time: Date.now()
    });
    try {
      //Removing the firebase token for push messages!
      //It's important that we do it before the logout otherwise the api request will fail
      yield removeFirebaseToken();
      yield logout();
      changeLoggedUserState(false);
      return true;
    } catch (e) {
      console.error(e);
      return false;
    }
  });
  return {
    isLogged,
    isUserLogged,
    changeLoggedUserState,
    login,
    checkIfUserIsLogged,
    doLogout
  };
});